import { createContext, useContext } from "react";
import type { CurrentUser } from "../global_functions/backpackSdk/auth/currentUser";

export type UserContextType = {
  initialized: boolean;
  currentUser?: CurrentUser | null;
  isLoading?: boolean;
  refreshCurrentUser: () => Promise<void>;
};

const initialContext: UserContextType = {
  initialized: false,
  refreshCurrentUser: async () => {},
  isLoading: true,
  currentUser: null,
};

const UserContext: React.Context<UserContextType> =
  createContext(initialContext);

export default UserContext;

export const useCurrentUser = () => {
  const { currentUser, initialized, ...userContext } = useContext(UserContext);
  if (!initialized) {
    throw new Error("useCurrentUser must be used within a UserContextProvider");
  }

  return { ...currentUser, ...userContext } as const;
};
